import React from 'react'
import { useMap } from 'react-leaflet'
import L from 'leaflet'
import { RouteData, RoutePath } from './mapTypes'

type Props = {
  routes: RouteData[]
  padding?: [number, number]
  paddingMobile?: [number, number]
}

const Bounds: React.FC<Props> = ({ routes, padding, paddingMobile }) => {
  const map = useMap()

  React.useEffect(() => {
    const path = routes
      .map(({ path }) => path.map<[number, number]>((p) => [p.lat, p.lon]))
      .reduce((acc, p) => [...acc, ...p])
    const bounds = L.latLngBounds(path)
    map.fitBounds(bounds, { animate: true, easeLinearity: 0.5, padding: !L.Browser.mobile ? padding : undefined, paddingBottomRight: L.Browser.mobile ? paddingMobile : undefined })
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [routes, map])

  return null
}

type DirectBoundsProps = {
  routes: Pick<RoutePath, 'lat' | 'lon'>[]
}

export const DirectBounds: React.FC<DirectBoundsProps> = React.memo(({ routes }) => {
  const map = useMap()

  React.useEffect(() => {
    const path = routes.map((route) => ({ lat: route.lat, lng: route.lon }))
    const bounds = L.latLngBounds(path)
    map.fitBounds(bounds)
  }, [routes, map])

  return null
})

export default React.memo(Bounds)
